import appLocalStorage from "app-local-storage";
import { authStorageKey } from "../consts";
import { AuthLocalStorage } from "../interfaces";

export class AuthService {
    loadStateFromStorage() {
        const lsAuth = appLocalStorage.get<AuthLocalStorage>(authStorageKey);
        return lsAuth;
    }
}